import React, { forwardRef } from 'react';
import { FieldTypes, urlRegexValidator} from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import DependencyTrackMappingForm from './DependencyTrackMappingForm';


const DependencyTrackCredentialsForm = forwardRef((props, ref) => {
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ]
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={DependencyTrackMappingForm}
        />
    )
});

export default DependencyTrackCredentialsForm;